import { useId, type ReactNode } from 'react';

/**
 * El logo de Patroclo: una cabeza de cabra de línea.
 *
 * Es el mismo dibujo que `IdeasLogoPatroclo/LogoPatroclo.jpg`, fuera del
 * repositorio. Va en línea y no como imagen porque así escala nítido de 20 px
 * a 200 px y toma el color de donde esté.
 *
 * - **insignia**: el círculo azul con los colores de la marca. El botón
 *   flotante, el encabezado del chat.
 * - **linea**: solo el trazo, en `currentColor`. Para el menú, donde va al
 *   lado de iconos de un solo color.
 */
export function LogoPatroclo({
  variante = 'insignia',
  className = '',
}: {
  variante?: 'insignia' | 'linea';
  className?: string;
}): ReactNode {
  // Un id por instancia: dos degradados con el mismo id en la página se pisan.
  const idCuerno = `cuerno-${useId()}`;
  const insignia = variante === 'insignia';

  return (
    <svg
      viewBox={insignia ? '16 16 208 208' : '44 32 152 176'}
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      {insignia && (
        <>
          <defs>
            <linearGradient id={idCuerno} x1="0" y1="1" x2="0" y2="0">
              <stop offset="0" stopColor="#a3b52a" />
              <stop offset="1" stopColor="#c9d934" />
            </linearGradient>
          </defs>
          <circle cx="120" cy="120" r="104" fill="#004a7a" />
        </>
      )}
      <g fill={insignia ? `url(#${idCuerno})` : 'currentColor'}>
        <path d="M115 88 C 110 52, 82 36, 52 44 C 76 50, 94 64, 100 90 Z" />
        <path d="M125 88 C 130 52, 158 36, 188 44 C 164 50, 146 64, 140 90 Z" />
      </g>
      <g
        fill="none"
        stroke={insignia ? '#ffffff' : 'currentColor'}
        strokeWidth={insignia ? 8 : 11}
        strokeLinejoin="round"
        strokeLinecap="round"
      >
        <path d="M95 102 C 79 99, 63 103, 51 114 C 65 122, 81 124, 94 120" />
        <path d="M145 102 C 161 99, 177 103, 189 114 C 175 122, 159 124, 146 120" />
        <path d="M98 88 H142 L146 124 L130 164 L120 172 L110 164 L94 124 Z" />
      </g>
      <g fill={insignia ? '#ffffff' : 'currentColor'}>
        <circle cx="109" cy="118" r="5" />
        <circle cx="131" cy="118" r="5" />
      </g>
      <path d="M112 178 Q120 182 128 178 L120 202 Z" fill={insignia ? '#f59d34' : 'currentColor'} />
    </svg>
  );
}
